// Application Constants
export const OWNER_EMAIL = process.env.REACT_APP_OWNER_EMAIL || 'bagheltelecom99@gmail.com';
export const SALES_MANAGER_EMAIL = process.env.REACT_APP_SALES_MANAGER_EMAIL || 'a2ztak99@gmail.com';

// User Roles
export const USER_ROLES = {
  OWNER: 'owner',
  SALES_MANAGER: 'sales_manager'
};

// Permissions
export const PERMISSIONS = {
  // Owner permissions
  OWNER: [
    'view_dashboard',
    'manage_sales',
    'manage_purchases', 
    'manage_suppliers',
    'view_reports',
    'export_data',
    'delete_records',
    'manage_users',
    'view_all_data'
  ],
  
  // Sales Manager permissions
  SALES_MANAGER: [
    'view_dashboard',
    'manage_sales',
    'view_reports',
    'export_sales_data'
  ]
};

// Helper function to get user role
export const getUserRole = (userEmail) => {
  if (userEmail === OWNER_EMAIL) {
    return USER_ROLES.OWNER;
  } else if (userEmail === SALES_MANAGER_EMAIL) {
    return USER_ROLES.SALES_MANAGER;
  }
  return null;
};

// Helper function to check permissions
export const hasPermission = (userEmail, permission) => {
  const role = getUserRole(userEmail);
  if (!role) return false;
  
  return PERMISSIONS[role.toUpperCase()]?.includes(permission) || false;
};